import { useCallback, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import _ from "lodash"
import { useVenue } from "providers/venue"
import { Q_VENUE } from "../constant"

type FilterByVenueId = (venueId: string) => void

interface IUseServiceAndTouristResult {
  filteredServiceAndTouristByVenue: IFilteredServiceAndTouristByVenue[]
}

interface IServiceAndTourist {
  id: string
  image: string
  location: {
    id: string
  }
  name: {
    en: string
  }
}

interface IFilteredServiceAndTouristByVenue extends IServiceAndTourist {
  venue_id: string
  level_name: string
}

type UseServiceAndTourist = (
  service: IServiceAndTourist[],
  venueFilter?: string
) => IUseServiceAndTouristResult

export const useServiceAndTourist: UseServiceAndTourist = (
  serviceAndTourist,
  venueFilter
) => {
  const [, setSearchParams] = useSearchParams()
  const { findFeatureById } = useVenue()

  const filterByVenueId: FilterByVenueId = useCallback(
    (venueId) => {
      if (venueId) setSearchParams({ [Q_VENUE]: venueId }, { replace: true })
    },
    [setSearchParams]
  )

  const preparedServiceAndTourist = useMemo(
    () =>
      _.map(serviceAndTourist, (location) => {
        const featureId = _.get(location, "location.id")
        const levelName = _.get(
          findFeatureById(featureId),
          "properties.level_name"
        )
        const venueId = _.get(findFeatureById(featureId), "properties.venue_id")
        return { ...location, level_name: levelName, venue_id: venueId }
      }),
    [serviceAndTourist, findFeatureById]
  )

  const filteredServiceAndTouristByVenue = useMemo(
    () =>
      preparedServiceAndTourist.filter(
        ({ venue_id }) => venueFilter === venue_id
      ),
    [preparedServiceAndTourist, venueFilter]
  )

  return {
    filterByVenueId,
    filteredServiceAndTouristByVenue,
  }
}
